import React from "react";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const Prompt = ({ onClose, onOk, visible, onSave }) => {
  
  return (
    <>
      <Dialog
        centered
        open={visible}
        onClose={onClose}        
      >
        <DialogTitle closeButton>
          Warning!
        </DialogTitle>
        <DialogContent>
        <DialogContentText>You are now leaving this page, do you want to save your changes?</DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button onClick={(e) => onSave(e)}>
            yes
          </Button>
          <Button  onClick={onOk}>
            No
          </Button>
          <Button  onClick={onClose}>
            Cancel
          </Button>
        </DialogActions>    
      </Dialog>
    </>
  );
};

export default Prompt;